(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired115"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired115"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jrCsX", function(module, exports) {

$parcel$export(module.exports, "initialize_select2", function () { return $e27e6083f8ee1b57$export$efc38d65eafcd66e; });
function $e27e6083f8ee1b57$export$efc38d65eafcd66e(root = document) {
    var _window_rebredgVendors, _$_fn;
    const $ = (_window_rebredgVendors = window.rebredgVendors) === null || _window_rebredgVendors === void 0 ? void 0 : _window_rebredgVendors.select2Jquery;
    if (!($ === null || $ === void 0 ? void 0 : (_$_fn = $.fn) === null || _$_fn === void 0 ? void 0 : _$_fn.select2)) return;
    root.querySelectorAll('.rebredg-cf7-form select').forEach((select)=>{
        var _placeholderOption_textContent;
        if (select.dataset.select2Initialized === 'true') return;
        const field = select.closest('.rebredg-form-field') || select.parentElement;
        const placeholderOption = [
            ...select.options
        ].find((option)=>!option.value || option.value === '0');
        $(select).select2({
            width: '100%',
            placeholder: select.dataset.placeholder || (placeholderOption === null || placeholderOption === void 0 ? void 0 : (_placeholderOption_textContent = placeholderOption.textContent) === null || _placeholderOption_textContent === void 0 ? void 0 : _placeholderOption_textContent.trim()) || '',
            closeOnSelect: !select.multiple,
            dropdownParent: field ? $(field) : undefined,
            minimumResultsForSearch: select.multiple ? Infinity : 8
        });
        const updateMultipleState = ()=>{
            if (!select.multiple || !field) return;
            const values = $(select).val();
            const hasSelection = Array.isArray(values) ? values.length > 0 : Boolean(values);
            field.classList.toggle('has-selection', hasSelection);
            const inlineSearch = field.querySelector('.select2-search--inline');
            if (inlineSearch) inlineSearch.remove();
            const selection = field.querySelector('.select2-selection--multiple');
            if (selection) {
                selection.setAttribute('tabindex', '0');
                selection.setAttribute('aria-label', field.dataset.label || select.getAttribute('aria-label') || 'Choose options');
            }
        };
        if (select.multiple && field) {
            updateMultipleState();
            $(select).on('select2:open', ()=>{
                field.classList.add('is-active');
                window.requestAnimationFrame(()=>{
                    var _field_querySelector;
                    (_field_querySelector = field.querySelector('.select2-search--inline')) === null || _field_querySelector === void 0 ? void 0 : _field_querySelector.remove();
                });
            }).on('select2:close', ()=>{
                field.classList.remove('is-active');
            }).on('select2:select select2:unselect change', updateMultipleState);
            field.addEventListener('keydown', (event)=>{
                var _event_target_closest, _event_target;
                const selection = (_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, '.select2-selection--multiple');
                if (!selection) return;
                if ([
                    'Enter',
                    ' ',
                    'ArrowDown'
                ].includes(event.key)) {
                    event.preventDefault();
                    $(select).select2('open');
                }
                if (event.key === 'Escape') $(select).select2('close');
            });
        }
        const syncSelect2 = ()=>{
            $(select).trigger('change.select2');
            updateMultipleState();
        };
        const observer = new MutationObserver(syncSelect2);
        observer.observe(select, {
            attributes: true,
            attributeFilter: [
                'disabled',
                'aria-busy'
            ],
            childList: true,
            subtree: true
        });
        select.dataset.select2Initialized = 'true';
    });
}

});



var $jrCsX = parcelRequire("jrCsX");
function $421447051c82e6e4$var$getFileFieldLabel(input) {
    var _field_querySelector_textContent, _field_querySelector, _input_closest_textContent, _input_closest, _input_getAttribute;
    const field = input.closest('.rebredg-form-field');
    const explicitLabel = (field === null || field === void 0 ? void 0 : (_field_querySelector = field.querySelector('.rebredg-form-field-label')) === null || _field_querySelector === void 0 ? void 0 : (_field_querySelector_textContent = _field_querySelector.textContent) === null || _field_querySelector_textContent === void 0 ? void 0 : _field_querySelector_textContent.trim()) || ((_input_closest = input.closest('label')) === null || _input_closest === void 0 ? void 0 : (_input_closest_textContent = _input_closest.textContent) === null || _input_closest_textContent === void 0 ? void 0 : _input_closest_textContent.trim()) || ((_input_getAttribute = input.getAttribute('aria-label')) === null || _input_getAttribute === void 0 ? void 0 : _input_getAttribute.trim());
    if (explicitLabel) {
        const cleanedLabel = explicitLabel.replace(/\s+/g, ' ').split(/\s+[–—-]\s+/)[0].trim();
        if (cleanedLabel) return cleanedLabel;
    }
    const normalizedName = (input.name || '').replace(/[\[\]_-]+/g, ' ').trim().toLowerCase();
    if (/\b(cv|resume)\b/.test(normalizedName)) return 'Your CV';
    if (/\b(additional|attachment|attachments|files?)\b/.test(normalizedName)) return 'Additional Files';
    const fallback = normalizedName.replace(/\b\w/g, (letter)=>letter.toUpperCase()).replace(/\bCv\b/g, 'CV');
    return fallback || 'Choose a file';
}
function $421447051c82e6e4$var$initializeFileAttachments(block) {
    block.querySelectorAll('.careers-page-form input[type="file"]').forEach((input)=>{
        const control = input.closest('.wpcf7-form-control-wrap') || input.parentElement;
        if (!control || input.dataset.fileAttachmentInitialized === 'true') return;
        const defaultLabel = $421447051c82e6e4$var$getFileFieldLabel(input);
        const visual = document.createElement('span');
        const fileName = document.createElement('span');
        control.classList.add('careers-file-attachment');
        input.classList.add('careers-file-attachment-input');
        visual.className = 'careers-file-attachment-ui';
        visual.setAttribute('aria-hidden', 'true');
        fileName.className = 'careers-file-attachment-name';
        visual.append(fileName);
        control.appendChild(visual);
        const syncFileName = ()=>{
            const files = Array.from(input.files || []);
            if (!files.length) {
                fileName.textContent = defaultLabel;
                control.classList.remove('has-file');
                return;
            }
            fileName.textContent = files.length === 1 ? files[0].name : `${files[0].name} +${files.length - 1}`;
            control.classList.add('has-file');
        };
        input.addEventListener('change', syncFileName);
        syncFileName();
        input.dataset.fileAttachmentInitialized = 'true';
    });
}
function $421447051c82e6e4$export$306aad10ee2f0a75(root = document) {
    root.querySelectorAll('[data-component="careers-page"]').forEach((block)=>{
        if (block.dataset.careersInitialized === 'true') return;
        (0, $jrCsX.initialize_select2)(block);
        $421447051c82e6e4$var$initializeFileAttachments(block);
        const { Swiper: Swiper, SwiperModules: SwiperModules = {} } = window.rebredgVendors || {};
        const slider = block.querySelector('[data-careers-swiper]');
        const previous = block.querySelector('[data-careers-previous]');
        const next = block.querySelector('[data-careers-next]');
        const pagination = block.querySelector('[data-careers-pagination]');
        const titleField = block.querySelector('[data-careers-title-field]');
        const defaultView = block.querySelector('[data-careers-default]');
        const thankYou = block.querySelector('[data-careers-thank-you]');
        const thankYouHeading = block.querySelector('[data-careers-thank-you-heading]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const readMoreDuration = reducedMotion ? 0 : 420;
        let careersSwiper = null;
        let heightAnimationFrame = 0;
        const syncRoleFields = ()=>{
            var _careersSwiper_slides;
            if (!titleField) return;
            const activeSlide = (careersSwiper === null || careersSwiper === void 0 ? void 0 : (_careersSwiper_slides = careersSwiper.slides) === null || _careersSwiper_slides === void 0 ? void 0 : _careersSwiper_slides[careersSwiper.activeIndex]) || (slider === null || slider === void 0 ? void 0 : slider.querySelector('.swiper-slide-active')) || (slider === null || slider === void 0 ? void 0 : slider.querySelector('.swiper-slide'));
            const showTitleField = (activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.dataset.showTitleField) === '1';
            titleField.hidden = !showTitleField;
            titleField.querySelectorAll('input, select, textarea, button').forEach((control)=>{
                control.disabled = !showTitleField;
            });
        };
        const syncSwiperHeight = ()=>{
            if (!careersSwiper) return;
            if (heightAnimationFrame) window.cancelAnimationFrame(heightAnimationFrame);
            if (reducedMotion) {
                careersSwiper.updateAutoHeight(0);
                return;
            }
            const startedAt = performance.now();
            const update = (now)=>{
                careersSwiper.updateAutoHeight(0);
                heightAnimationFrame = now - startedAt < readMoreDuration ? window.requestAnimationFrame(update) : 0;
            };
            heightAnimationFrame = window.requestAnimationFrame(update);
        };
        block.querySelectorAll('[data-careers-read-more]').forEach((button)=>{
            const slide = button.closest('.careers-page-slide');
            const description = slide === null || slide === void 0 ? void 0 : slide.querySelector('[data-careers-description]');
            const label = button.querySelector('[data-careers-read-more-label]');
            if (!description || !label) return;
            const collapsedHeight = Number.parseFloat(window.getComputedStyle(description).getPropertyValue('--careers-description-collapsed-height')) || 103;
            if (description.scrollHeight <= collapsedHeight + 1) {
                description.style.maxHeight = 'none';
                description.classList.add('is-unclipped');
                button.remove();
                return;
            }
            description.style.maxHeight = `${collapsedHeight}px`;
            button.addEventListener('click', ()=>{
                const nextExpanded = button.getAttribute('aria-expanded') !== 'true';
                button.setAttribute('aria-expanded', String(nextExpanded));
                label.textContent = nextExpanded ? button.dataset.lessLabel : button.dataset.moreLabel;
                description.classList.toggle('is-expanded', nextExpanded);
                if (nextExpanded) description.style.maxHeight = `${description.scrollHeight}px`;
                else window.requestAnimationFrame(()=>{
                    description.style.maxHeight = `${collapsedHeight}px`;
                });
                syncSwiperHeight();
            });
        });
        if (Swiper && slider) {
            const modules = [
                SwiperModules.EffectFade,
                SwiperModules.Navigation,
                SwiperModules.Pagination,
                SwiperModules.Keyboard,
                SwiperModules.A11y
            ].filter(Boolean);
            const hasMultipleRoles = slider.querySelectorAll('.swiper-slide').length > 1;
            careersSwiper = new Swiper(slider, {
                modules: modules,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: reducedMotion ? 0 : 550,
                autoHeight: true,
                allowTouchMove: hasMultipleRoles,
                grabCursor: hasMultipleRoles,
                rewind: hasMultipleRoles,
                watchOverflow: true,
                navigation: previous && next ? {
                    prevEl: previous,
                    nextEl: next
                } : false,
                pagination: pagination ? {
                    el: pagination,
                    clickable: true
                } : false,
                keyboard: {
                    enabled: hasMultipleRoles,
                    onlyInViewport: true
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous role',
                    nextSlideMessage: 'Next role',
                    paginationBulletMessage: 'Go to role {{index}}'
                }
            });
            careersSwiper.on('slideChange', syncRoleFields);
            careersSwiper.updateAutoHeight(0);
        }
        syncRoleFields();
        if (thankYou) block.addEventListener('wpcf7mailsent', (event)=>{
            if (!(event.target instanceof Element) || !block.contains(event.target)) return;
            if (defaultView) defaultView.hidden = true;
            thankYou.hidden = false;
            block.classList.add('is-submitted');
            block.dataset.careersState = 'success';
            const blockTop = block.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: blockTop,
                behavior: reducedMotion ? 'auto' : 'smooth'
            });
            window.setTimeout(()=>{
                thankYouHeading === null || thankYouHeading === void 0 ? void 0 : thankYouHeading.focus({
                    preventScroll: true
                });
            }, reducedMotion ? 0 : 550);
        });
        block.dataset.careersInitialized = 'true';
    });
}


const $3ea021b52bf95886$var$runBlock = ()=>(0, $421447051c82e6e4$export$306aad10ee2f0a75)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $3ea021b52bf95886$var$runBlock, {
    once: true
});
else $3ea021b52bf95886$var$runBlock();

})();
//# sourceMappingURL=careers-page.js.map
